module.exports = __webpack_public_path__ + "assets/producthunt.f8584357.svg";